<template>
    <div class="flex-1">
        <skeleton v-if="plan === undefined" />
        <not-found v-else-if="plan === null" />
        <purchase-pass
            v-else
            :plan="plan"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PurchasePass from '~/components/PurchaseContract/Pass/PurchasePass.vue'
import { useQuery } from '@tanstack/vue-query'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'
import { useActiveFacility } from '~/composables/use-active-facility'
import Skeleton from 'primevue/skeleton'
import NotFound from '~/components/NotFound/NotFound.vue'
import { useCurrentDate } from '~/composables/use-current-date'

const props = defineProps<{ planId: string }>()
const planId = computed(() => props.planId)
const activeFacility = useActiveFacility()

const query = useRpQuery()
const currentDate = useCurrentDate()
const reactiveDate = computed(() => currentDate.value.getDate())
const { data } = useQuery({
    queryKey: ['PassPurchaseQuery', planId, activeFacility, reactiveDate],
    queryFn: () =>
        query(
            graphql(/* GraphQL */ `
                query PassPurchaseQuery(
                    $planId: ID!
                    $facilityId: ID!
                    $input: SimpleSpokeInput!
                ) {
                    plan(id: $planId) {
                        ...PurchasePassPlanFragment
                    }
                }
            `),
            {
                planId: planId.value,
                facilityId: activeFacility.value.id,
                input: {
                    facilityId: activeFacility.value.id
                }
            }
        )
})

const plan = computed(() => {
    if (data.value === undefined) {
        return undefined
    }

    if (data.value.plan === null) {
        return null
    }

    return data.value.plan
})
</script>
